import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    configuration: {},
    session: { active: false, created: null, saved: null },
    interface: {
        initialized: false,
        full_screen_width: false,
        not_full_screen_width: false,
        view_expanded: false,
        side_nav_expanded: false,
        view_title: '',
        view_type: '',
        view_links: [],
    },
    application: {},
    category: {},
    page: {},
    form: {},
}

export const settingSlice = createSlice({
    name: 'settings',
    initialState,
    reducers: {
        createSettings: (state, action) => {
            if (action?.payload) {
                if (
                    action?.['payload']?.['digital_name'] &&
                    action?.payload?.settings
                ) {
                    state[action?.payload?.digital_name] = {
                        ...state?.[action?.payload?.digital_name],
                        ...action.payload.settings,
                    }
                }
            }
        },
        updateSettings: (state, action) => {
            if (action?.payload) {
                if (
                    action?.['payload']?.['digital_name'] &&
                    action?.payload?.settings
                ) {
                    state[action?.payload?.digital_name] = {
                        ...state?.[action?.payload?.digital_name],
                        ...action.payload.settings,
                    }
                }
            }
        },
        deleteSettings: (state, action) => {
            if (action?.payload) {
                if (action?.['payload']?.['digital_name']) {
                    state[action?.payload?.digital_name] = {}
                }
            }
        },
    },
})

export const selectSettings = (state) => state.settings
export const { createSettings, updateSettings, deleteSettings } =
    settingSlice.actions
export default settingSlice.reducer
